"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../license");
var _react = _interopRequireDefault(require("react"));
var _swr = require("swr");
var _head = _interopRequireDefault(require("next/head"));
var _router = require("next/router");
var _google = require("@next/third-parties/google");
var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");
var _styles = require("@mui/material/styles");
var _CssBaseline = _interopRequireDefault(require("@mui/material/CssBaseline"));
var _fetcher = _interopRequireDefault(require("../helpers/fetcher"));
var _GlobalStyle = _interopRequireDefault(require("../layout/GlobalStyle"));
var _theme = require("../theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
_fontawesomeSvgCore.config.autoAddCss = false;
var LivePixApp = function LivePixApp(props) {
  var Component = props.Component,
    pageProps = props.pageProps;
  var router = (0, _router.useRouter)();
  var themePreference = router.query.theme;
  var _React$useState = _react["default"].useState(themePreference === "dark" ? "dark" : "light"),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    mode = _React$useState2[0],
    setMode = _React$useState2[1];
  var theme = _react["default"].useMemo(function () {
    return mode === "dark" ? _theme.darkTheme : _theme.lightTheme;
  }, [mode]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_google.GoogleTagManager, {
    gtmId: "GTM-5QXRLZK",
    nonce: props.nonce
  }), /*#__PURE__*/_react["default"].createElement(_head["default"], null, /*#__PURE__*/_react["default"].createElement("title", null, "LivePix - Notifica\xE7\xF5es de Pix para streamers"), /*#__PURE__*/_react["default"].createElement("link", {
    rel: "apple-touch-icon",
    sizes: "57x57",
    href: "https://static.livepix.gg/apple-icon-57x57.png"
  }), /*#__PURE__*/_react["default"].createElement("link", {
    rel: "apple-touch-icon",
    sizes: "60x60",
    href: "https://static.livepix.gg/apple-icon-60x60.png"
  }), /*#__PURE__*/_react["default"].createElement("link", {
    rel: "apple-touch-icon",
    sizes: "72x72",
    href: "https://static.livepix.gg/apple-icon-72x72.png"
  }), /*#__PURE__*/_react["default"].createElement("link", {
    rel: "apple-touch-icon",
    sizes: "76x76",
    href: "https://static.livepix.gg/apple-icon-76x76.png"
  }), /*#__PURE__*/_react["default"].createElement("link", {
    rel: "apple-touch-icon",
    sizes: "114x114",
    href: "https://static.livepix.gg/apple-icon-114x114.png"
  }), /*#__PURE__*/_react["default"].createElement("link", {
    rel: "apple-touch-icon",
    sizes: "120x120",
    href: "https://static.livepix.gg/apple-icon-120x120.png"
  }), /*#__PURE__*/_react["default"].createElement("link", {
    rel: "apple-touch-icon",
    sizes: "144x144",
    href: "https://static.livepix.gg/apple-icon-144x144.png"
  }), /*#__PURE__*/_react["default"].createElement("link", {
    rel: "apple-touch-icon",
    sizes: "152x152",
    href: "https://static.livepix.gg/apple-icon-152x152.png"
  }), /*#__PURE__*/_react["default"].createElement("link", {
    rel: "apple-touch-icon",
    sizes: "180x180",
    href: "https://static.livepix.gg/apple-icon-180x180.png"
  }), /*#__PURE__*/_react["default"].createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "192x192",
    href: "https://static.livepix.gg/android-icon-192x192.png"
  }), /*#__PURE__*/_react["default"].createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "32x32",
    href: "https://static.livepix.gg/favicon-32x32.png"
  }), /*#__PURE__*/_react["default"].createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "96x96",
    href: "https://static.livepix.gg/favicon-96x96.png"
  }), /*#__PURE__*/_react["default"].createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "16x16",
    href: "https://static.livepix.gg/favicon-16x16.png"
  }), /*#__PURE__*/_react["default"].createElement("link", {
    rel: "manifest",
    href: "https://static.livepix.gg/manifest.json"
  }), /*#__PURE__*/_react["default"].createElement("meta", {
    name: "msapplication-TileColor",
    content: "#ffffff"
  }), /*#__PURE__*/_react["default"].createElement("meta", {
    name: "msapplication-TileImage",
    content: "https://static.livepix.gg/ms-icon-144x144.png"
  }), /*#__PURE__*/_react["default"].createElement("meta", {
    name: "theme-color",
    content: "#ffffff"
  }), /*#__PURE__*/_react["default"].createElement("meta", {
    name: "viewport",
    content: "minimum-scale=1, initial-scale=1, width=device-width"
  })), /*#__PURE__*/_react["default"].createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_CssBaseline["default"], null), /*#__PURE__*/_react["default"].createElement(_GlobalStyle["default"], null), /*#__PURE__*/_react["default"].createElement(_swr.SWRConfig, {
    value: {
      fetcher: _fetcher["default"]
    }
  }, /*#__PURE__*/_react["default"].createElement(Component, pageProps))));
};
var _default = exports["default"] = LivePixApp;